<!--suppress ALL -->
<template>
    <div>
        <menu-bar/>
        <div class="container" role="main">
            <div class="row" style="margin-top: 50px">

                <ol class="breadcrumb">
                    <li>
                        <a href="#/">
                            <i class="fa fa-home" aria-hidden="true"></i> INICIAL
                        </a>
                    </li>
                    <li class="active"><i class="fa fa-suitcase" aria-hidden="true"></i> CAIXAS PAC-PON</li>
                </ol>

                <div class="row">
                    <div class="col-md-3">
                        <caixas-pac-pon-menu/>
                    </div>
                    <div class="col-md-9">

                        <div class="col-md-6">
                            <label for="nome" class="control-label">BUSCA POR NOME DAS CAIXAS PAC-PON</label>
                            <input id="nome" type="text" v-model="nome" class="form-control">
                        </div>

                        <div class="col-md-2">
                            <label for="cto" class="control-label">CTO</label>
                            <select id="cto" v-model="cto" class="form-control">
                                <option v-for="c in ctos" :value="c" v-bind:key="c">{{c}}</option>
                            </select>
                        </div>

                        <div class="col-md-4">
                            <br/>
                            <blockquote class="blockquote-reverse">
                                Total de PAC-PON: <b>{{ getContratos.length }}</b>
                            </blockquote>
                        </div>

                        <div class="col-md-12" style="margin-top: 20px">

                            <table id="mytable" class="table table-bordred table-striped">

                                <thead>
                                    <tr>
                                        <th style="text-align: center;width: 80px">PON ID</th>
                                        <th>NOME</th>
                                        <th style="text-align: center;width: 140px">CTO</th>
                                        <th style="text-align: center;width: 140px">FIBRA</th>
                                        <th style="text-align: center;width: 140px">AÇÕES</th>
                                    </tr>
                                </thead>

                                <tbody>

                                    <tr v-for="r in getContratos" v-bind:key="r._id">
                                        <td class="text-center">{{ (r.porta_pon) ? r.porta_pon.pon_id : null }}</td>
                                        <td>{{ r.nome }}</td>
                                        <td class="text-center">CTO-{{ r.cto.numero }}</td>
                                        <td class="text-center">FO-{{ r.fibra.numero }}</td>
                                        <td style="text-align: center">
                                            <a :href="'#/caixa-pacpon/add/' + r._id" class="btn btn-primary btn-xs">
                                                ABRIR <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                                            </a> &nbsp;
                                            <button @click="excluir(r._id)" v-if="user.level < 3" class="btn btn-danger btn-xs">
                                                <i class="fa fa-trash" aria-hidden="true"></i>
                                            </button>
                                        </td>
                                    </tr>

                                </tbody>

                            </table>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { CaixasPacPonMenu } from "../../components/exports";
import { CaixaPacPon } from "../../class/index";

export default {
    components: {
        CaixasPacPonMenu
    },
    data() {
        return {
            contratos: [],
            user: null,
            ctos: [],
            cto: null,
            nome: null
        };
    },
    computed: {
        getContratos: function() {
            if (!this.nome && !this.cto) {
                return this.contratos;
            }
            return this.contratos.filter(player => {
                if (this.cto && this.nome) {
                    return (
                        player.nome
                            .toLowerCase()
                            .includes(this.nome.toLowerCase()) &&
                        player.cto.numero === this.cto
                    );
                } else if (this.cto) {
                    return player.cto.numero === this.cto;
                } else if (this.nome) {
                    return player.nome
                        .toLowerCase()
                        .includes(this.nome.toLowerCase());
                }
            });
        }
    },
    beforeMount() {
        this.user = this.$store.state.user;
        this.load();
    },
    methods: {
        excluir(id) {
            // eslint-disable-next-line no-undef
            swal.queue([
                {
                    title: "EXCLUIR",
                    confirmButtonText: "Excluir",
                    text: "Posso excluir a caixa?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise(resolve => {
                            CaixaPacPon.excluir(id)
                                .then(() => {
                                    this.load();
                                    resolve();
                                })
                                .catch(err => {
                                    console.error(err);
                                    resolve();
                                });
                        });
                    }
                }
            ]);
        },

        async load() {
            this.contratos = await CaixaPacPon.all();
            this.contratos.forEach(c => {
                if (!this.ctos.includes(c.cto.numero)) {
                    this.ctos.push(c.cto.numero);
                }
            });
        }
    }
};
</script>
